import Image from 'next/image';
import { Box } from '@zillow/constellation-10';
import { LoadingImage } from '@zg-rentals/loading-components';
import type { Document } from '../../../../../models/rental-application';

type Props = {
  documents: Array<Document>;
  isPending: boolean;
};

export function OverviewDocumentThumbnails({ documents, isPending }: Props) {
  return (
    <Box
      css={{
        display: 'grid',
        gridTemplateColumns: 'repeat(10, 1fr)',
        gap: 'default',
        marginTop: 'loose',
        marginBottom: 'loose',
      }}
    >
      {documents
        .filter((document: Document) => !!document.id && (document.previewUrl || isPending))
        .map((document: Document) => (
          <Box css={{ gridColumnEnd: { base: 'span 10', md: 'span 5', xl: 'span 2' } }} key={document.id}>
            {document.previewUrl ? (
              <Box
                css={{
                  position: 'relative',
                  height: '2400',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Image
                  src={String(document.previewUrl)}
                  alt={`Preview image for ${document.fileName}`}
                  fill
                  style={{
                    maxWidth: '100%',
                    objectFit: 'contain',
                  }}
                />
              </Box>
            ) : (
              <LoadingImage isLoading loadingWidth="100%" loadingHeight="96px" />
            )}
          </Box>
        ))}
    </Box>
  );
}
